import React from "react";
import { Theme } from "@mui/material";
import UpIcon from "@icons/positive.svg?react";
import DownIcon from "@icons/negative.svg?react";
import { toPercent } from "@helpers";

type Props = {
  value: number;
  reverseColor?: boolean;
  theme?: Theme;
  showIcons?: boolean;
};

export const GainLossChartPercents = ({
  value,
  reverseColor = false,
  theme,
  showIcons: showIcons = true,
}: Props) => {
  if (!theme) return null;

  const icons =
    showIcons &&
    (value < 0 ? (
      <DownIcon width="10px" height="8px" />
    ) : (
      <UpIcon width="10px" height="8px" />
    ));

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing(0.5, 2),
        fontWeight: 600,
        fontSize: theme.typography.body3.fontSize,
        lineHeight: theme.typography.body2.lineHeight,
        letterSpacing: theme.typography.body2.letterSpacing,
        borderRadius: theme.shape.borderRadius,
        gap: theme.spacing(1),
        backgroundColor:
          value >= 0 && !reverseColor
            ? theme.palette.background.success
            : theme.palette.background.error,
        color:
          value >= 0 && !reverseColor
            ? theme.palette.text.positive
            : theme.palette.text.negative,
      }}
    >
      <span
        style={{
          fontSize: theme.typography.caption.fontSize,
          lineHeight: theme.typography.caption.lineHeight,
        }}
      >
        {toPercent(value).replace(/\s/, "")}
      </span>
      {icons}
    </div>
  );
};
